import React, { useEffect, useState } from 'react'
import PageHead from '../components/PageHead'
import { exportButton } from '../utils/config'
import { CiExport } from 'react-icons/ci'
import Button from '../ui/comp/Button'
import { FiEdit, FiEye, FiPlus } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import Input from '../ui/forms/Input'
import { useCustomers } from '../hooks/useCustomers'
import Loading from '../components/Loading'
import Container from '../ui/comp/Container'
import NoContent from '../components/NoContent'
import Table from '../ui/Table/Table'
import Thead from '../ui/Table/Thead'
import Td from '../ui/Table/Td'
import Tbody from '../ui/Table/Tbody'
import { CgTrash } from 'react-icons/cg'
import ReactPaginate from 'react-paginate'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'

function Customers() {

    const [customers, setCustomers] = useState([])

    const [searchText, setSearchText] = useState("");


    const [page, setPage] = useState(1);
    const limit = 50
    const [totalPages, setTotalPages] = useState(0)

    const { data, isLoading, refetch } = useCustomers(page, limit, searchText);

    useEffect(() => {
        setTotalPages(data?.totalPages)
        setCustomers(data?.customers || [])
    }, [data])



    if (isLoading) {
        return (
            <div>
                <Loading />
            </div>
        )
    }

    return (
        <div className='w-full relative'>
            {/* Head */}
            <PageHead title={"Customers"} />

            {/* Filter palce */}
            <div className="flex items-center justify-between w-full mt-8">
                <div className='max-w-48 w-full'>
                    <Button
                        onClick={() => exportButton("users")}
                        color={'primary'}
                        icon={<CiExport size={18} />}
                    >
                        Export
                    </Button>
                </div>

                <div className='flex items-center gap-3'>
                    <Input placeholder="Customer name" onChange={(e) => {
                        setSearchText(e.target.value)
                        setTimeout(() => {
                            refetch()
                        }, 500);
                    }} />
                    <Button icon={<FiPlus />} >Add Customer</Button>
                </div>
            </div>



            {/*  Data*/}
            <div className="w-full relative mt-7">
                {customers && customers?.length ? (
                    <Container>
                        <div className="w-full relative">
                            <Table>
                                <Thead>
                                    <tr>
                                        <Td>Joining Date</Td>
                                        <Td>Name</Td>
                                        <Td>Email</Td>
                                        <Td>Actions</Td>
                                    </tr>
                                </Thead>

                                <Tbody>
                                    {customers?.map((customer, i) => (
                                        <tr key={i}>
                                            <Td>{new Date(customer?.iat).toLocaleString('en-GH', { dateStyle: 'medium' })}</Td>
                                            <Td>{`${customer?.firstname} ${customer?.lastname}`}</Td>
                                            <Td>{`${customer?.email}`}</Td>
                                            <Td>
                                                <div className="flex items-center gap-3 text-gray-500">
                                                    <Link className='text-primary' to={`/customers/${customer?.id}`} title='Edit'><FiEdit size={18} /></Link>
                                                    <Link className='text-gray-500' to={`/customers/${customer?.id}`} title='view'><FiEye size={18} /></Link>
                                                    <button title='Delete' className='text-red-400'><CgTrash size={18} /></button>
                                                </div>
                                            </Td>
                                        </tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </div>


                        {/* Pagination */}
                        <div className="p-2 flex justify-end">
                            <ReactPaginate
                                nextLabel={<FaChevronRight />}
                                previousLabel={<FaChevronLeft />}
                                previousClassName='mr-2 text-primary/80'
                                nextClassName='ml-2 text-primary/80'
                                containerClassName='flex text-sm items-center gap-2'
                                activeClassName='bg-primary text-white'
                                pageClassName='size-8 rounded-lg bg-gray-100 flex items-center justify-center'
                                pageCount={totalPages}
                                onPageChange={({ selected }) => {
                                    setPage(selected + 1)
                                }}
                            />
                        </div>
                    </Container>
                ) : <NoContent />}
            </div>


        </div >
    )
}

export default Customers